

<template>
  <div>
    <div class="vx-row mb-6" v-for="item in integracoes" :key="item.id">
      <div class="vx-col sm:w-1/1 w-full">
        <vx-card>
          <h3>{{ item.nomeFornecedor }}</h3>
          <div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-4">
                <formIntegracao :objUpdate="item" @concluido="buscaDados()" />
              </div>
              <div v-if="item.possuiDePara" class="vx-col sm:w-2/3 w-full mt-4">
                <button
                  class="
                    vs-component vs-button vs-button-primary vs-button-gradient
                  "
                  @click="openDePara(item)"
                  type="gradient"
                >
                  De/Para
                </button>
                <formIntegracaoDePara
                  :objUpdate="item.dePara"
                  :objGeral="item"
                  @concluido="openDePara(item)"
                />
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import service from "./../../../services";
import locale from "./../../../locale";
import Datepicker from "vuejs-datepicker";
import { Money } from "v-money";
import moment from "moment";
import BotaoSubmit from "../../../components/BotaoSubmit";
import formIntegracao from "./../../forms/formIntegracao.vue";
import formIntegracaoDePara from "./../../forms/formIntegracaoDePara.vue";
export default {
  components: {
    Datepicker,
    Money,
    BotaoSubmit,
    formIntegracao,
    formIntegracaoDePara,
  },
  data() {
    return {
      aguardeCadastro: false,
      integracoes: [],
      form: {},
      passo: 0,
    };
  },
  methods: {
    openDePara(item) {
      console.log(item);
      this.aguardeCadastro = true;
      this.$vs.loading();
      service
        .post("integracoes", "buscaDePara", item)
        .then((res) => {
          this.aguardeCadastro = false;
          this.$vs.loading.close();
          console.log(res.data);
          item.dePara = res.data;
          this.$forceUpdate();
        })
        .catch((error) => {
          this.aguardeCadastro = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
        });
    },
    onSubmit() {
      console.log(this.form);
      this.form.dadosProposta = this.dadosProposta;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          this.$vs.loading();
          service
            .post("Cotacao", "AtualizarPropostaGeral", this.form)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });
              this.$emit("concluido");
              this.buscaDados();
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },
    preencheForm() {},
    buscaDados() {
      this.$vs.loading();
      var objSend = {};
      objSend.idEmpresa = this.idEmpresa;
      objSend.notDeleted = true;
      service
        .post("integracoes", "list", objSend)
        .then((res) => {
          this.integracoes = [];
          if (res.data.length > 0) {
            console.log(res.data);
            res.data.forEach((element) => {
              if (element.jsonFacilitador) {
                element.jsonFacilitador = JSON.parse(element.jsonFacilitador);
                element.parametros = element.parametros
                  ? JSON.parse(element.parametros)
                  : {};
                this.integracoes.push(element);
              }
            });
            //this.integracoes = res.data;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },

    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .getAll("g", {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          this[array].push({ label: "Selecione", id: null });
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
  },
  mounted() {
    this.$validator.localize("ptBr", locale);
    this.buscaDados();
  },
};
</script>
<style >
.vdp-datepicker input {
  width: 100%;
}
</style>

<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}
.forceWhite:hover {
  color: #fff !important;
}
</style>